import { type TaskMetadataWithReviewQuestion } from '@exam-management/graphql';
import { Alert, Flex, PaperSection, ReadonlyField, Text } from '@shared/components';

import { useQuestionReviewTaskDetails } from '../../providers';
import { QuestionList } from '../question-list';

export default function SubtaskQuestionDetailsSection() {
  const { taskDetails, questions } = useQuestionReviewTaskDetails();

  const metadata = taskDetails.parentTask?.metadata as TaskMetadataWithReviewQuestion | undefined;

  const reviewedQuestionCount = questions.filter(({ verdicts }) => verdicts.length > 0).length;

  return (
    <PaperSection title='Question Details'>
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          p: theme.spacing(6),
          gap: theme.spacing(6),
        })}
      >
        <ReadonlyField label='คลังข้อสอบ' content={metadata?.qBankStructure?.name ?? ''} />
        <ReadonlyField label='รายละเอียดเพิ่มเติม' content={taskDetails.description ?? ''} />
        <Alert severity='info'>
          <Text variant='body1'>คลิกที่คำถามแต่ละข้อเพื่อให้ความเห็น</Text>
        </Alert>
        <QuestionList
          endAdornment={
            <Text variant='body1'>{`${reviewedQuestionCount}/${questions.length} Reviewed`}</Text>
          }
        />
      </Flex>
    </PaperSection>
  );
}
